import { IApiError } from "@faire/web-api--source/indigofair/data/IApiError";

export class LoginError extends Error {
  constructor(
    message: string,
    public httpStatusCode?: number,
    public responseBody?: IApiError
  ) {
    super(message);
  }
}
